import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { useNavigate } from "react-router-dom";
import { Button, Grid } from "@mui/material";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

import { useEffect } from "react";
import swal from "sweetalert";
import { makeGetRequest, makePostRequest } from "../../../utils/utils";
import dayjs from "dayjs";
import { Formik, Form } from "formik";
import * as Yup from "yup";

// For Date Picker
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
// End

// For Tab
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
// End

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function CreateInvoiceWithTab() {
  const navigate = useNavigate();

  // For Tab
  const [value2, setValue2] = React.useState(0);

  const handleChange2 = (event, newValue) => {
    setValue2(newValue);
  };
  // End

  const [ownersList, setOwnersList] = React.useState([]);
  const [apartmentList, setApartmentList] = React.useState([]);
  const [q, setQ] = React.useState("");
  const [selectedOwner, setSelectedOwner] = React.useState("");
  const [selectedApartment, setSelectedApartment] = React.useState("");

  // const [ownerData, setOwnerData] = React.useState({});

  const [invoiceNo, setInvoiceNo] = React.useState(0);
  const [invoice_date, setInvoiceDate] = React.useState(dayjs(new Date()));
  const [due_date, setDueDate] = React.useState(invoice_date.add(15, "day"));
  const [subject, setSubject] = React.useState("");

  const [billto, setBillTo] = React.useState("");
  const [wing] = React.useState("");
  const [apartmentNo, setApartmentNo] = React.useState("");
  const [contactNo, setContactNo] = React.useState("");
  const [emailId, setEmailId] = React.useState("");

  const [note, setNote] = React.useState("");
  // const [cgst, setCgst] = React.useState(10);
  // const [sgst, setSgst] = React.useState(10);
  const [cgstAmt] = React.useState(0);
  const [sgstAmt] = React.useState(0);
  const [subTotal, setSubTotal] = React.useState(0);
  const [advanceReceived] = React.useState(100);
  const [past_due, setPastDue] = React.useState(0);
  const [lateFee, setLateFee] = React.useState(0);
  const [totalPayable, setTotalPayable] = React.useState(0);
  const [maintenenceIdList, setMaintenenceIdList] = React.useState([]);
  const [maintenenceList, setMaintenenceList] = React.useState([]);

  const [taxList, setTaxList] = React.useState([]);

  // const [added_maintenenceList, setAddedMaintenenceList] = React.useState([]);
  const [added_maintenenceName] = React.useState("");
  const [added_maintenenceAmount] = React.useState();

  const [appliedTaxJsonList] = React.useState([]);

  // const [tax,setTax]=React.useState({taxName:"",taxtAmount:""});
  // const [calculatedTaxList, setcalculatedTaxList] = React.useState([]);
  // const [taxList, setTaxList] = React.useState([]);

  const getAddedMaintenence = (e) => {
    alert("On Blur called");
  };

  const Validation_Schema = Yup.object().shape({
    subject: Yup.string()
      .required("Required")
      .matches(
        /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
        "Numbers not allowed!!"
      ),
    note: Yup.string()
      .required("Required")
      .matches(
        /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
        "Numbers not allowed!!"
      ),
  });

  var formikInitials = {
    subject: subject,
    note: note,
  };

  async function OwnerListing() {
    let bodyFormData = {};
    // alert(q)
    makeGetRequest("resident/getall", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          // console.log("Owner Data");
          // console.log(response.data.data);
          // setlength(response.data.data.rowCount);
          const data = response.data.data;
          setOwnersList(data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function MaintenenceListing() {
    let bodyFormData = {};

    makeGetRequest("maintenence/getallbystatus/true", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          console.log("Maintenence Data");
          console.log(response.data.data);
          // setlength(response.data.data.rowCount);
          const data = response.data.data;
          setMaintenenceList(data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  // const [value, setValue] = React.useState(0);

  // const handleChange = (e, newValue) => {
  //   setValue(newValue);
  // };

  const handlechangeOwner = (e) => {
    setSelectedOwner(e.target.value);
    console.log("Building Data ", e);

    makeGetRequest("resident/getalldetails/" + e.target.value, "")
      .then((response) => {
        if (response.status === 201) {
          console.log("Owner Obj");
          console.log(response.data);
          // setlength(response.data.data.rowCount);
          const data = response.data.data;
          // setOwnerData(data);
          setApartmentList(response.data.apartmentList);
          setBillTo(data.user_obj.first_name + " " + data.user_obj.last_name);
          setEmailId(data.user_obj.email_id);
          setContactNo(data.user_obj.contact_no);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
    // setOwnerData()
  };

  async function handlechangeApartment(selectedApartmentId) {
    alert(selectedApartmentId);
    var selectedApartment = selectedApartmentId;
    setSelectedApartment(selectedApartmentId);
    var total = 0;
    for (var i = 0; i < apartmentList.length; i++) {
      if (apartmentList[i].apartment_id == selectedApartment) {
        var apartmentObj = apartmentList[i];
        console.log("selected Apartment ", apartmentObj);
        setApartmentNo(apartmentObj.uniq_apt_name);

        for (var j = 0; j < maintenenceList.length; j++) {
          maintenenceIdList[j] = maintenenceList[j].maintenence_id;
          console.log("Before total ", total);
          total = total + maintenenceList[j].amount;
          console.log("After total ", total);
        }
        var tax = 0;
        var previousMonthTotPayable = 0;
        for (var k = 0; k < taxList.length; k++) {
          console.log("In Tax For loop");

          var calculatedTax;
          if (taxList[k].tax_name === "Late Fee") {
            alert(
              "selectedOwner " +
                selectedOwner +
                " selectedApartment " +
                selectedApartment
            );
            alert(taxList[k].tax_amount);
            let latefeeAmt = taxList[k].tax_amount;
            let previousInvoice = "";
            await makeGetRequest(
              "invoice/getpreviousmonth/" +
                selectedOwner +
                "/" +
                selectedApartment,
              ""
            )
              .then((response) => {
                if (response.status == "201") {
                  console.log(response.data.data);
                  previousInvoice = response.data.data;
                }
              })
              .catch((err) => {
                swal("There was an error!", "more error details", "warning");
              });

            if (previousInvoice) {
              if (previousInvoice.is_paid) {
                alert("Invoice is paid");
                alert(new Date(previousInvoice.due_date).getTime());

                if (
                  new Date(previousInvoice.paid_date).getTime() >
                  new Date(previousInvoice.due_date).getTime()
                ) {
                  //Apply late fee
                  alert("Late Fee applicable");
                  alert(latefeeAmt);
                  // +' taxList[k] '+taxList[k].tax_amount);
                  var calculated_lateFee = (total * latefeeAmt) / 100;
                  taxList[k].calculatedTax = calculated_lateFee;
                  tax = tax + calculated_lateFee;
                  setLateFee(calculated_lateFee);
                  alert(calculated_lateFee);
                }
              } else {
                let calculated_lateFee = (total * taxList[k].tax_amount) / 100;
                taxList[k].calculatedTax = calculated_lateFee;
                tax = tax + calculated_lateFee;

                previousMonthTotPayable = previousInvoice.total_payment;
                setPastDue(previousMonthTotPayable);
                setLateFee(calculated_lateFee);
              }
            }
          } else {
            calculatedTax = (total * taxList[k].tax_amount) / 100;
            taxList[k].calculatedTax = calculatedTax;
            tax = tax + calculatedTax;
          }
          console.log("calculatedTaxList ", taxList);
        }

        setMaintenenceIdList(maintenenceIdList);
        console.log("maintenenceList ", maintenenceIdList);

        setSubTotal(total + tax);

        setTotalPayable(total - advanceReceived + tax);
        console.log("Subtotal ", subTotal);
      }
    }
  }

  // For Date Picker
  // const [value1, setValue1] = React.useState(new dayjs());

  const handleInvoiceDate = (newValue) => {
    setInvoiceDate(newValue);
    setDueDate(invoice_date.add(1, "month"));
  };

  // const [value2, setValue2] = React.useState(dayjs('2014-08-18T21:11:54'));
  const handleDueDate = (newValue) => {
    setDueDate(newValue);
  };
  // End

  async function TaxListing() {
    let bodyFormData = {};

    await makeGetRequest("tax/getallbystatus/true", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          console.log("Tax details Data");
          console.log(response.data.data);
          // setlength(response.data.data.rowCount);
          const data = response.data.data;
          setTaxList(data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  const deleteField = () => {
    alert("No click delete this Field");
  };

  async function saveInvoice() {
    alert("In Save Invoice");
    // const [appliedTaxJson,setAppliedTaxJson]=React.useState({key:'',value:''});
    let appliedTaxJson;
    let total = 0;

    if (invoice_date && due_date && selectedOwner) {
      let maintenenceJsonList = [];
      let maintenenceObj = { maintenenceName: "TEst Maintenence", amount: 500 };
      maintenenceJsonList.push(maintenenceObj);

      for (var i = 0; i < maintenenceList.length; i++) {
        appliedTaxJson = { key: "", value: "" };
        appliedTaxJson.key = maintenenceList[i].maintenence_type;
        appliedTaxJson.value = maintenenceList[i].amount;
        total = total + maintenenceList[i].amount;
        appliedTaxJsonList.push(appliedTaxJson);
      }
      for (var i = 0; i < taxList.length; i++) {
        appliedTaxJson = { key: "", value: "" };
        if (taxList[i].tax_name === "Late Fee") {
          appliedTaxJson.key = taxList[i].tax_name;
          appliedTaxJson.value = lateFee;
          appliedTaxJsonList.push(appliedTaxJson);
        } else {
          appliedTaxJson.key = taxList[i].tax_name;
          appliedTaxJson.key = taxList[i].tax_name;
          appliedTaxJson.value = (total * taxList[i].tax_amount) / 100;
          appliedTaxJsonList.push(appliedTaxJson);
        }
      }

      let inputdata = {
        invoice_date: invoice_date,
        due_date: due_date,
        resident_id: selectedOwner,
        apartment_id: selectedApartment,
        maintenenceid_list: maintenenceIdList,
        maintenence_json_list: appliedTaxJsonList,
        total_payment: subTotal,
        advance_received: advanceReceived,
        is_paid: false,
        past_due: past_due,
        late_fee: lateFee,
      };

      makePostRequest("invoice/insert", inputdata)
        .then((response) => {
          if (response.data.data !== undefined) {
            swal("Success", "Invoice Created Successully....", "success", {
              timer: 1000,
              buttons: false,
            });

            // let invoicemailData={
            //   invoiceHtml:invoiceHtml
            // }
            // makePostRequest("invoice/sendemail", invoicemailData)
            // .then((response) => {
            //   if (response.data.data !== undefined) {
            //     alert('Mail Send');
            //   }});

            navigate("/InvoiceListing");
          }
        })
        .catch((err) => {
          swal("There was an error!", "more error details", "warning");
        });
    } else {
      swal("Please fill all details!", "", "warning");
    }
  }

  async function getMaxInvoiceId() {
    console.log("In Get Max Invoice Id");
    await makeGetRequest("invoice/getmaxid", "")
      .then((response) => {
        if (response.data.data !== undefined) {
          console.log("Max Id ", response.data.data.rows[0].maxid);
          setInvoiceNo(response.data.data.rows[0].maxid + 1);
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }
  // For Append
  const { useState } = React;
  const AddedElement = () => (
    <div className="addedAppendLine" id="deleteId">
      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <select className="inputSt">
            <option>Hall</option>
            <option>Select 1</option>
            <option>Select 2</option>
          </select>
        </Grid>
        <Grid item xs={12} md={8}>
          <input
            className="inputSt"
            placeholder="Banquet Hall"
            value={added_maintenenceName}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <div className="inputWithICon">
            <CurrencyRupeeIcon />
            <input
              type="text"
              className="inputSt"
              placeholder="3500"
              value={added_maintenenceAmount}
              onBlur={(event) => getAddedMaintenence()}
            />
          </div>
        </Grid>
      </Grid>
      <Button className="minusBtn" onClick={deleteField}>
        <RemoveIcon />
      </Button>
    </div>
  );
  const [count, setCount2] = useState(0);
  // End

  // const addAminitiesClick = () => {
  //   var element = document.getElementById("addAminitiesId");
  //   element.classList.add("aminitiesMainAdd");
  // };

  useEffect(() => {
    getMaxInvoiceId();
    OwnerListing();
    MaintenenceListing();
    TaxListing();

    var total = 0;

    for (var j = 0; j < maintenenceList.length; j++) {
      maintenenceIdList[j] = maintenenceList[j].maintenence_id;
      console.log("Before total ", total);
      total = total + maintenenceList[j].amount;
      console.log("After total ", total);
    }

    setSubTotal(total);
    // setCgstAmt(total*cgst/100);
    //setSgstAmt(total*sgst/100);
    setTotalPayable(total - advanceReceived + cgstAmt + sgstAmt);
    console.log("Subtotal ", subTotal);
  }, [q]);
  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Create Invoice</h1>
            <Button className="primaryBtn sendInvoiceBt sendInvoiceBt2">
              Send Invoice
            </Button>
            <Button className="primaryBtn" onClick={() => navigate("")}>
              Create New Invoice
            </Button>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <Formik
              enableReinitialize
              initialValues={formikInitials}
              validationSchema={Validation_Schema}
              onSubmit={saveInvoice}
            >
              {({
                values,
                handleChange,
                errors,
                setFieldTouched,
                touched,
                isValid,
                handleSubmit,
              }) => (
                <Form>
                  <div className="invoiceMain">
                    <div className="invoicePaidUnpaidTabMain createInvoTabMain">
                      <Box sx={{ width: "100%" }}>
                        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                          <Tabs
                            value={value2}
                            onChange={handleChange2}
                            aria-label="basic tabs example"
                          >
                            <Tab
                              label="Miscellaneous Invoices"
                              {...a11yProps(0)}
                            />
                            <Tab
                              label="Monthly Maintenance Invoices"
                              {...a11yProps(1)}
                            />
                          </Tabs>
                        </Box>
                        <TabPanel value={value2} index={0}>
                          <div className="invoiceInnerMain">
                            <Grid container spacing={3}>
                              <Grid item xs={12} md={4}>
                                <input
                                  className="inputSt"
                                  placeholder="Search by Name"
                                  onChangeCapture={(e) => setQ(e.target.value)}
                                />
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <select
                                  className="inputSt"
                                  value={selectedOwner}
                                  onChange={handlechangeOwner}
                                  onBlur={() =>
                                    setFieldTouched("selectedOwner")
                                  }
                                  // onChangeCapture={(e) => setSelectedOwner(e.target.value)}
                                >
                                  <option>Select Owner</option>
                                  {ownersList.map((option) => (
                                    <option
                                      key={option.resident_id}
                                      value={option.resident_id}
                                      data-isd={
                                        option.user_obj.first_name +
                                        " " +
                                        option.user_obj.last_name
                                      }
                                    >
                                      {option.user_obj.first_name +
                                        " " +
                                        option.user_obj.last_name}
                                    </option>
                                  ))}
                                </select>
                                {errors.selectedOwner &&
                                touched.selectedOwner ? (
                                  <div
                                    style={{ color: "red" }}
                                    className="errorField"
                                  >
                                    {errors.selectedOwner}
                                  </div>
                                ) : null}
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <select
                                  className="inputSt"
                                  value={selectedApartment}
                                  onChange={(e) =>
                                    handlechangeApartment(e.target.value)
                                  }
                                >
                                  <option>Select Apartment</option>
                                  {apartmentList.map((option) => (
                                    <option
                                      key={option.apartment_id}
                                      value={option.apartment_id}
                                      data-isd={option.uniq_apt_name}
                                    >
                                      {option.uniq_apt_name}
                                    </option>
                                  ))}
                                </select>
                              </Grid>
                            </Grid>
                            <Grid container>
                              <Grid item xs={12} md={12}>
                                <h2 className="invoiceSubHeading">
                                  Create Invoice
                                </h2>
                              </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                              <Grid item xs={12} md={4}>
                                <label className="tabsLabel">Invoice #</label>
                                <input
                                  className="inputSt"
                                  placeholder="267345"
                                  value={invoiceNo}
                                />
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <label className="tabsLabel">
                                  Invoice Date
                                </label>
                                <div className="dateTimeMain">
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <Stack className="inputSt">
                                      <DesktopDatePicker
                                        inputFormat="MM/DD/YYYY"
                                        value={invoice_date}
                                        onChange={handleInvoiceDate}
                                        renderInput={(params) => (
                                          <TextField {...params} />
                                        )}
                                      />
                                    </Stack>
                                  </LocalizationProvider>
                                </div>
                                {/* <input type="date" className="inputSt" value={values.invoice_date} onChange={handleInvoiceDate} /> */}
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <label className="tabsLabel">Due Date</label>
                                <div className="dateTimeMain">
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <Stack className="inputSt">
                                      <DesktopDatePicker
                                        inputFormat="MM/DD/YYYY"
                                        value={due_date}
                                        onChange={handleDueDate}
                                        renderInput={(params) => (
                                          <TextField {...params} />
                                        )}
                                      />
                                    </Stack>
                                  </LocalizationProvider>
                                </div>
                                {/* <input type="date" className="inputSt" value={values.due_date} onChange={handleDueDate} /> */}
                              </Grid>
                              <Grid item xs={12} md={12}>
                                <input
                                  className="inputSt"
                                  placeholder="Subject"
                                  value={values.subject}
                                  onChange={handleChange("subject")}
                                  onBlur={() => setFieldTouched("subject")}
                                  onChangeCapture={(e) =>
                                    setSubject(e.target.value)
                                  }
                                />
                                {errors.subject && touched.subject ? (
                                  <div
                                    style={{ color: "red" }}
                                    className="errorField"
                                  >
                                    {errors.subject}
                                  </div>
                                ) : null}
                                <Grid item xs={12} md={12}></Grid>
                              </Grid>
                            </Grid>

                            <Grid container>
                              <Grid item xs={12} md={12}>
                                <h2 className="invoiceSubHeading">BIll to</h2>
                              </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                              <Grid item xs={12} md={4}>
                                <input
                                  type="text"
                                  className="inputSt"
                                  placeholder="Jarome Bell"
                                  disabled
                                  value={billto}
                                />
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <input
                                  className="inputSt"
                                  placeholder="WIng-B"
                                  disabled
                                  value={wing}
                                />
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <input
                                  className="inputSt"
                                  placeholder="Flat No. 204"
                                  disabled
                                  value={apartmentNo}
                                />
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <div className="inputWithICon">
                                  <LocalPhoneIcon />
                                  <input
                                    className="inputSt"
                                    placeholder="9823898485"
                                    disabled
                                    value={contactNo}
                                  />
                                </div>
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <div className="inputWithICon">
                                  <MailOutlineIcon />
                                  <input
                                    className="inputSt"
                                    placeholder="sample@gmail.com"
                                    disabled
                                    value={emailId}
                                  />
                                </div>
                              </Grid>
                            </Grid>

                            <Grid container>
                              <Grid item xs={12} md={12}>
                                <h2 className="invoiceSubHeading">
                                  Maintenance Details
                                </h2>
                              </Grid>
                            </Grid>
                            {maintenenceList.map((option) => (
                              <Grid container spacing={3}>
                                <Grid item xs={12} md={7}>
                                  <input
                                    className="inputSt"
                                    value={option.maintenence_type}
                                  />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                  <div className="inputWithICon">
                                    <CurrencyRupeeIcon />

                                    <input
                                      className="inputSt"
                                      value={parseFloat(option.amount).toFixed(
                                        2
                                      )}
                                    />
                                  </div>
                                </Grid>
                              </Grid>
                            ))}
                            {taxList.map((option) => (
                              <Grid container spacing={3}>
                                <Grid item xs={12} md={7}>
                                  <input
                                    className="inputSt"
                                    value={option.tax_name}
                                  />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                  <div className="inputWithICon">
                                    <CurrencyRupeeIcon />
                                    <input
                                      className="inputSt"
                                      value={parseFloat(
                                        option.calculatedTax
                                      ).toFixed(2)}
                                    />
                                  </div>
                                </Grid>
                              </Grid>
                            ))}
                            <div
                              className="addAminitiesMain"
                              id="addAminitiesId"
                            >
                              <Grid container>
                                {/* <Grid item xs={12} md={12}>
                                  <Button
                                    className="addAminitiesBt"
                                    onClick={addAminitiesClick}
                                  >
                                    <AddIcon /> Add Other Maintenance
                                  </Button>
                                </Grid> */}
                                <Grid item xs={12} md={12}>
                                  <div className="showingAminities">
                                    <Grid container>
                                      <Grid item xs={12} md={12}>
                                        <h2 className="invoiceSubHeading">
                                          Miscellaneous Details
                                        </h2>
                                      </Grid>
                                    </Grid>

                                    {/*For Append */}
                                    {[...Array(count)].map((_, i) => (
                                      <AddedElement key={i} />
                                    ))}
                                    {/* End */}

                                    <div className="appendLine">
                                      <Grid container spacing={3}>
                                        <Grid item xs={12} md={12}>
                                          <select className="inputSt">
                                            <option>Hall</option>
                                            <option>Select 1</option>
                                            <option>Select 2</option>
                                          </select>
                                        </Grid>
                                        <Grid item xs={12} md={8}>
                                          <input
                                            className="inputSt"
                                            placeholder="Maintenence Name"
                                          />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                          <div className="inputWithICon">
                                            <CurrencyRupeeIcon />
                                            <input
                                              className="inputSt"
                                              placeholder="Amount"
                                              onBlur={(event) =>
                                                getAddedMaintenence()
                                              }
                                            />
                                          </div>
                                        </Grid>
                                      </Grid>
                                      <Button
                                        className="plusBtn"
                                        onClick={() => setCount2(count + 1)}
                                      >
                                        <AddIcon />
                                      </Button>
                                    </div>
                                  </div>
                                </Grid>
                              </Grid>
                            </div>

                            <Grid container>
                              <Grid item xs={12} md={12}>
                                <h2 className="invoiceSubHeading">
                                  Calculate Invoice
                                </h2>
                              </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                              <Grid item xs={12} md={12}>
                                <input
                                  className="inputSt"
                                  placeholder="Notes"
                                  value={values.note}
                                  onChange={handleChange("note")}
                                  onBlur={() => setFieldTouched("note")}
                                  onChangeCapture={(e) =>
                                    setNote(e.target.value)
                                  }
                                />
                                {errors.note && touched.note ? (
                                  <div
                                    style={{ color: "red" }}
                                    className="errorField"
                                  >
                                    {errors.note}
                                  </div>
                                ) : null}
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <label className="tabsLabel">Sub total</label>
                                <div className="inputWithICon">
                                  <CurrencyRupeeIcon />
                                  <input
                                    className="inputSt"
                                    placeholder="7000"
                                    value={parseFloat(subTotal).toFixed(2)}
                                  />
                                </div>
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <label className="tabsLabel">
                                  Advance Recived
                                </label>
                                <div className="inputWithICon">
                                  <CurrencyRupeeIcon />
                                  <input
                                    className="inputSt"
                                    placeholder="3000"
                                    value={parseFloat(advanceReceived).toFixed(
                                      2
                                    )}
                                  />
                                </div>
                              </Grid>

                              <Grid item xs={12} md={4}>
                                <label className="tabsLabel">
                                  Total Payable
                                </label>
                                <div className="inputWithICon">
                                  <CurrencyRupeeIcon />
                                  <input
                                    className="inputSt"
                                    placeholder="4000"
                                    value={parseFloat(totalPayable).toFixed(2)}
                                  />
                                </div>
                              </Grid>
                            </Grid>

                            <Grid container>
                              <Grid
                                item
                                xs={12}
                                md={12}
                                className="previewBtOuter"
                              >
                                <Button
                                  className="addBt PreviewBtn"
                                  onClick={() => saveInvoice()}
                                >
                                  Preview
                                </Button>
                                {/* <Button
                            className="addBt PreviewBtn"
                            onClick={() => navigate("/InvoicePreview")}
                          >
                            Preview
                          </Button> */}
                              </Grid>
                            </Grid>
                          </div>
                        </TabPanel>
                        <TabPanel value={value2} index={1}>
                          <div className="visitorListNewInner">No Data</div>
                        </TabPanel>
                      </Box>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default CreateInvoiceWithTab;
